/**
 * Widget-local hook: builds the main + AES charts from table results.
 */

import { useEffect, useState } from "react";

import createChart from "utils/chartUtil";

const useStatisticCharts = ({
  mainTableResult,
  aesTableResult,
  units,
  decimalPlaces,
}) => {
  const [chart, setChart] = useState(null);
  const [aesChart, setAesChart] = useState(null);

  useEffect(() => {
    if (mainTableResult && mainTableResult.length) {
      setChart(
        createChart({
          tableResult: mainTableResult,
          units,
          yAxisDecimalPlaces: decimalPlaces,
          yDomainMode: "data",
        })
      );
    } else {
      setChart(null);
    }

    if (aesTableResult && aesTableResult.length) {
      setAesChart(
        createChart({
          tableResult: aesTableResult,
          units,
          yAxisDecimalPlaces: decimalPlaces,
          showZeroBaseline: true,
          yDomainMode: "data",
        }),
      );
    } else {
      setAesChart(null);
    }
  }, [mainTableResult, aesTableResult, units, decimalPlaces]);

  return { chart, aesChart };
};

export default useStatisticCharts;
